import { useTranslate } from "ra-core";

import { MobileContent } from "../layout/MobileContent";
import MobileHeader from "../layout/MobileHeader";
import { ProjectSwitcher } from "../projects/ProjectSwitcher";
import LeadList from "./LeadList";

/**
 * «Лиды» on a phone: the same board as on a desktop; it scrolls sideways
 * inside itself, the page does not.
 */
export const LeadListMobile = () => {
  const translate = useTranslate();
  return (
    <>
      <MobileHeader showRefresh>
        <div className="flex items-center gap-3 min-w-0">
          <h1 className="text-xl font-semibold">
            {translate("crm.navigation.leads")}
          </h1>
          <ProjectSwitcher className="max-w-40" />
        </div>
      </MobileHeader>
      <MobileContent>
        <LeadList />
      </MobileContent>
    </>
  );
};
